export default {
  data: [
    {
      id: 1,
      client_id: 1,
      title: "title",
      path: "https://picsum.photos/400",
      treatment_id: 1,
      created: "11/27/2019"
    },
    {
      id: 2,
      client_id: 2,
      title: "title 2",
      path: "https://picsum.photos/400",
      treatment_id: 1,
      created: "7/21/2019"
    },
    {
      id: 3,
      client_id: 2,
      title: "title 3",
      path: "https://picsum.photos/400",
      treatment_id: 1,
      created: "12/5/2019"
    },
    {
      id: 4,
      client_id: 3,
      title: "title 1",
      path: "https://picsum.photos/400",
      treatment_id: 2,
      created: "8/7/2019"
    },
    {
      id: 5,
      client_id: 3,
      title: "title",
      path: "https://picsum.photos/400",
      treatment_id: 3,
      created: "1/25/2020"
    },
    {
      id: 6,
      client_id: 3,
      title: "title 6",
      path: "https://picsum.photos/400",
      treatment_id: 3,
      created: "7/28/2019"
    },
    {
      id: 7,
      client_id: 4,
      title: "title 7",
      path: "https://picsum.photos/400",
      treatment_id: 3,
      created: "2/12/2020"
    },
    {
      id: 8,
      client_id: 5,
      title: "title 8",
      path: "https://picsum.photos/400",
      treatment_id: 5,
      created: "12/6/2019"
    },
    {
      id: 9,
      client_id: 6,
      title: "title 9",
      path: "https://picsum.photos/400",
      treatment_id: 4,
      created: "3/18/2019"
    },
    {
      id: 10,
      client_id: 6,
      title: "title 10",
      path: "https://picsum.photos/400",
      treatment_id: 5,
      created: "2/28/2020"
    }
  ]
};
